import React, { Fragment, useEffect, useState } from 'react';
import { Button, Input, InputNumber, Select } from 'antd';
import { LayoutForm } from './flota'
import { Label } from '../../views/contactanos/contactanos';
import { useModelosCotizar } from '../../../hooks/Front/formularios/useFormularios';
import { checkIsNotEmpty, tipeoNumero } from '../../../helper/validations';
import { errorSwal } from '../../../helper/swalHelpers';



const Mantencion = ({ states }) => {

    const [filtro] = useState({
        Modulo: "MODELOS",
        idCategoria: 0,
        NumeroDePasajerosValorMax: "",
        NumeroDePasajerosValorMin: ""
    })
    const [form, setForm] = useState({
        tipo: 'mantencion',
        idModelo: undefined,
        mantencion: undefined,
        idVersion: undefined,
    });

    const [version, setVersion] = useState(undefined);
    const [versionI, setVersionI] = useState(undefined);
    const [modeloI, setModeloI] = useState(undefined);
    const [periodos, setPeriodos] = useState(undefined);
    const [producto, setProducto] = useState(undefined);
    console.log("🚀 -> Mantencion -> producto:", producto)
    const { idModelo, mantencion, idVersion } = form;

    const { modelos, loading: loadingM, error: errorM } = useModelosCotizar(filtro);

    const handleChange = (name, value) => {
        if (name === 'idModelo') {
            states.setProducto(undefined);
            let modelo = modelos[value];
            setModeloI(value);

            let mantencion = Number(modelo.MantencionDesc?.match(/\d/g)?.join("")) 

            if (!mantencion) {
                setVersionI(undefined);
                setForm({ ...form, idModelo: modelo.idVehiculo, idVersion: undefined, mantencion: undefined });
                setProducto(modelo);
                setPeriodos(undefined);
                return;
            }
            let periodo = [mantencion];

            let inicial = mantencion;
            let tope = 300000;
            for (let index = 2; periodo[periodo.length - 1] < tope; index++) {
                periodo.push(inicial * index);
            }
            setVersionI(undefined);
            setProducto(modelo);
            setPeriodos(periodo);

            if (modelo.versiones && modelo.versiones.length < 1) {
                setForm({ ...form, idModelo: modelo.idVehiculo, idVersion: modelo.idVersion, mantencion: undefined });
                return;
            }

            setForm({ ...form, idModelo: modelo.idVehiculo, idVersion: undefined, mantencion: undefined });
            return;
        }
        if (name === 'mantencion') {
            setForm({ ...form, mantencion: value });
            return;
        }
        if (name === 'idVersion') {
            const version = producto.versiones[value];
            version.tipoMoneda = producto.tipoMoneda ? producto.tipoMoneda : "CLP";
            setVersion(version);
            setVersionI(value);
            setForm({ ...form, idVersion: version.idVersion });
            return;
        }

    };

    const checkForm = () => {
        if (!checkIsNotEmpty(idModelo) ||
            !checkIsNotEmpty(mantencion) ||
            !checkIsNotEmpty(idVersion)) {
            return false;
        }
        return true;
    }

    const handleSubmit = () => {
        if (!checkForm()) {
            errorSwal("Ocurrió un error", "Recuerda ingresar todos los campos requeridos.", "Ok");
            return;
        }
        states.setProducto({
            Nombre: producto.Nombre,
            Imagen: producto.Imagen,
            tipo: "mantencion",
            Mantencion: form.mantencion,
            Version: version.Version
        })
        states.setFormP(form);
        states.setPaso(1);
    }

    const handleChangeMantencion = (v) => {
        setForm({ ...form, mantencion: v })
    }

    useEffect(() => {
        // if (states.formProducto) {

        //     let state = states.formProducto;
        //     setForm({ idModelo: state.idModelo, mantencion: state.mantencion });
        // }
    }, [states.formProducto])

    const getViewPortWidth = () => {
        let viewportwidth;
        // the more standards compliant browsers (mozilla/netscape/opera/IE7) use window.innerWidth and window.innerHeight
        if (typeof window.innerWidth != 'undefined') {
            viewportwidth = window.innerWidth;
            // IE6 in standards compliant mode (i.e. with a valid doctype as the first line in the document)
        } else
            if (typeof document.documentElement != 'undefined' &&
                typeof document.documentElement.clientWidth != 'undefined' &&
                document.documentElement.clientWidth != 0) {
                viewportwidth = document.documentElement.clientWidth;
                // older versions of IE
            } else {
                viewportwidth = document.getElementsByTagName('body')[0].clientWidth;
            }
        return viewportwidth;
    }

    return (
        <>
            <LayoutForm>
                <p className="bold-title-hyundai f-responsive mb-3">Datos del vehículo</p>
                <Label texto="Modelo" />
                <Select value={modeloI} onChange={value => handleChange('idModelo', value)} className="w-100 hyundai-select" loading={loadingM} >
                    {modelos && modelos.length > 0 && errorM === false &&
                        modelos.map((modelo, i) =>
                            <Select.Option value={i} key={i}>{modelo.Nombre}</Select.Option>
                        )
                    }
                </Select>
            </LayoutForm>
            {producto && producto.versiones && producto.versiones.length > 0 &&
                <LayoutForm>
                    <Label texto="Versión" />
                    <Select value={versionI} className="w-100 hyundai-select" onChange={v => handleChange('idVersion', v)}>
                        {producto.versiones.map((modelo, i) =>
                            <Select.Option value={i} key={i}>{modelo.Version}</Select.Option>)
                        }
                    </Select>
                </LayoutForm>
            }
            <LayoutForm>
                <Label texto="Mantención" />
                {form.idModelo && periodos && periodos.length > 0 &&
                    <Select onChange={v => handleChange('mantencion', v)} value={mantencion} className="w-100 hyundai-select" >
                        {periodos.map((periodo, i) =>
                            <Select.Option value={periodo} key={i}>{periodos.length - 1 === i ? periodo.toLocaleString('es-CL') + ' km o más' : periodo.toLocaleString('es-CL') + ' km'}</Select.Option>
                        )}
                    </Select>
                }
                {form.idModelo && !periodos &&
                    <InputNumber
                        onChange={v => handleChangeMantencion(v)}
                        className="cotizar-input w-100"
                        min="1"
                    />
                }
                {!form.idModelo &&
                    <Select className="w-100 hyundai-select" >

                    </Select>
                }
            </LayoutForm>

            {
                getViewPortWidth() <= 768 ? (
                    <Fragment>
                        <div className='h-div-mantencion' />
                        <div className='col-btn-formulario-cotizar'>
                            <Button
                                className="btn-primario-cotizador font-btn w-100 f-responsive mb-3"
                                onClick={handleSubmit}
                            >
                                Siguiente
                            </Button>
                        </div>
                    </Fragment>
                ) : (
                    <LayoutForm>
                        <Button className="btn-primario font-btn w-100 f-responsive mb-5" onClick={handleSubmit}>Siguiente</Button>
                    </LayoutForm>
                )
            }
        </>
    );
}

export default Mantencion;